// Authentication
export const USER_LOGGEDIN = "USER_LOGGEDIN";
export const PASSWORD_CHANGED = "PASSWORD_CHANGED";
export const USER_REGISTERED = "USER_REGISTERED";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const AUTHENTICATED = "AUTHENTICATED";
export const SEND_RESET_CODE = "SEND_RESET_CODE";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const SHOW_RESET_MESSAGE = "SHOW_RESET_MESSAGE";
export const SHOW_CONFIRM_MESSAGE = "SHOW_CONFIRM_MESSAGE";
export const FETCH_LOGGEDIN_USER = "FETCH_LOGGEDIN_USER";
export const SERVER_ERRORS = "SERVER_ERRORS";
export const ADMINS_FETCHED = "ADMINS_FETCHED";
export const ADMIN_REMOVED = "ADMIN_REMOVED";
export const ADMIN_ADDED = "ADMIN_ADDED";
export const CURRENT_ADMIN = "CURRENT_ADMIN";
export const USER_PASSWORD_RESET = "USER_PASSWORD_RESET";
export const ROLES_FETCHED = "ROLES_FETCHED";
export const ROLE_ADDED = "ROLE_ADDED";
export const ROLE_UPDATED = "ROLE_UPDATED";
export const ROLE_DELETED = "ROLE_DELETED";

export const SIDE_MENU_COLLAPSED = "SIDE_MENU_COLLAPSED";
export const DETAIL_SHOWED = "DETAIL_SHOWED";
export const LOADING = "LOADING";

// Request
export const REQUEST_ADDED = "REQUEST_ADDED";
export const REQUEST_FETCHED = "REQUEST_FETCHED";
export const REQUEST_EDITED = "REQUEST_EDITED";
export const SET_REQUEST = "SET_REQUEST";
export const REQUEST_DELETED = "REQUEST_DELETED";
export const NEW_REQUESTS_COUNT = "NEW_REQUESTS_COUNT";
export const ASSIGNEE_EMPLOYEE = "ASSIGNEE_EMPLOYEE";
export const REQUEST_DIACTIVATED = "REQUEST_DIACTIVATED";

// sites
export const SITE_ADDED = "SITE_ADDED";
export const SITE_FETCHED = "SITE_FETCHED";
export const SITE_EDITED = "SITE_EDITED";
export const SET_SITE = "SET_SITE";
export const SITE_DELETED = "SITE_DELETED";
export const LOCATION_FETCHED = "LOCATION_FETCHED";
export const SITE_DOOR = "SITE_DOOR";


// DOORS
export const DOOR_ADDED = "DOOR_ADDED";
export const DOOR_FETCHED = "DOOR_FETCHED";
export const DOOR_EDITED = "DOOR_EDITED";
export const DOOR_DELETED = "DOOR_DELETED";
export const SET_DOOR = "SET_DOOR";

// approver
export const APPROVER_ADDED = "APPROVER_ADDED";
export const APPROVER_FETCHED = "APPROVER_FETCHED";
export const APPROVER_EDITED = "APPROVER_EDITED";
export const APPROVER_DELETED = "APPROVER_DELETED";
export const SET_APPROVER = "SET_APPROVER";
export const APPROVER_INFO = "APPROVER_INFO";
export const APPROVER_LOCATIONS = "APPROVER_LOCATIONS";
export const APPROVE_REQUEST = "APPROVE_REQUEST";
export const REJECT_REQUEST = "REJECT_REQUEST";
export const APPROVE_LOADING = "APPROVE_LOADING";
export const REJECTED = "REJECTED";
export const EMPLOYEE_ASSIGNED = "EMPLOYEE_ASSIGNED";

// Dashboard Data
export const PIECHART_DATA_FETCHED = "PIECHART_DATA_FETCHED";
export const LINECHART_DATA_FETCHED = "LINECHART_DATA_FETCHED";
export const CARD_DATA_FETCHED = "CARD_DATA_FETCHED";

// Delegation
export const DELEGATE_FETCHED = "DELEGATE_FETCHED";
export const CURRENT_DELEGATE = "CURRENT_DELEGATE";
export const DELEGATE_ADDED = "DELEGATE_ADDED";
export const DELEGATE_EDITED = "DELEGATE_EDITED";
export const DELEGATE_REMOVED = "DELEGATE_REMOVED";
export const SET_DELEGATE = "SET_DELEGATE";

//DelegationByAdmin
export const DELEGATEBYADMIN_ADDED = "DELEGATEBYADMIN_ADDED";
export const DELEGATEBYADMIN_FETCHED = "DELEGATEBYADMIN_FETCHED";
export const DELEGATEBYADMIN_DELETED = "DELEGATEBYADMIN_DELETED";


// Report
export const REQUESTS_BY_STATUS = "REQUESTS_BY_STATUS";
export const REQUESTS_BY_TYPE = "REQUESTS_BY_TYPE";
export const EXPORT_REQUESTS_BY_STATUS= "EXPORT_REQUESTS_BY_STATUS";
export const EXPORT_REQUESTS_BY_TYPE= "EXPORT_REQUESTS_BY_TYPE";
export const EXPORT_REQUESTS_BY_TYPE_DATERANGE= "EXPORT_REQUESTS_BY_TYPE_DATERANGE";
export const EXPORT_REQUESTS_BY_STATUS_DATERANGE= "EXPORT_REQUESTS_BY_STATUS_DATERANGE";
export const UNIFIED_REPORT = "UNIFIED_REPORT";
export const EXPORT_UNIFIED_REPORT = "EXPORT_UNIFIED_REPORT";


//employee
export const EMPLOYEE_FETCHED= "EMPLOYEE_FETCHED";
export const IMPORT_EMPLOYEES= "IMPORT_EMPLOYEES";




